import { Component } from '@angular/core';
import { CheckoutService } from '../../order-fulfillment/checkout.service';

/*
 * preview: /play/pl/cart/play24addToCart/checkout
 */

@Component({
  selector: 'play24-checkout-component',
  templateUrl: './play24-checkout.component.html',
})
export class Play24CheckoutComponent {
  constructor(
    private checkoutService: CheckoutService,
  ) {
    this.checkoutService.controlOrderProgress();
  }
}


